import { faEye, faPen, faPlus, faTrash, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useFormikContext } from "formik";
import { cloneDeep } from "lodash";
import React, { useState } from "react";
import { Button } from "react-bootstrap";

import { OIAgriculturalIncomeDetailsForm } from ".";
import { IAgriculturalIncomes, IFormITR1, IReviewOSIncomes } from "../../../config/interfaces";
import { useAppSelector } from "../../../redux/Store";
import { ITRFilingSelector } from "../../../redux/slice/ITRFilingSlice";
import FASvgIcon from "../../FASvgIcon";
import PreventEditComponent from "../../PreventEditComponent";
import PriceDisplay from "../../PriceDisplay";
import { ConfirmationModal } from "../../modals";

const OIAgriculturalIncomeDetails: React.FC = () => {
	const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

	const [showAddFormCanvas, setShowAddFormCanvas] = useState<boolean>(false);
	const [showDeleteModal, setShowDeleteModal] = useState<IAgriculturalIncomes | null>(null);

	const { values, setFieldValue, setValues } = useFormikContext<IFormITR1>();
	const AgriculturalIncomesDetails = values?.IncomeDetails?.AgriculturalIncomes;

	const handleTotalCalculation = (incomeData: IAgriculturalIncomes | null) => {
		const OtherSourcesIncomes: IReviewOSIncomes = {
			...values.OthersInc,
			TotalAgriculturalIncome: incomeData?.AgrNetIncome || 0
		};
		const TotalIncomeOthSrc = Object.values(OtherSourcesIncomes)?.reduce((acc, curr) => {
			return acc + curr;
		}, 0);

		const DATA = {
			OthersInc: OtherSourcesIncomes,
			IncomeOthSrc: TotalIncomeOthSrc
		};

		setValues({ ...cloneDeep(values), ...DATA });
		setFieldValue("IncomeDetails.AgriculturalIncomes", incomeData);
	};

	return (
		<>
			<section className="mb-5">
				<div className="section-title-wrap">
					<h5>
						Agricultural Income
						<small>Income from agricultural activities like farming etc.</small>
					</h5>
					<PreventEditComponent>
						{AgriculturalIncomesDetails ? (
							<Button variant="warning" size="sm" onClick={() => setShowAddFormCanvas(() => true)}>
								<FASvgIcon icon={faPen} />
								Edit
							</Button>
						) : (
							<Button
								variant="secondary"
								size="sm"
								onClick={() => setShowAddFormCanvas(() => true)}
							>
								<FASvgIcon icon={faPlus} />
								Add
							</Button>
						)}
					</PreventEditComponent>

					{isFilingReadOnly && (
						<Button
							variant="warning"
							size="sm"
							className="text-white"
							onClick={() => setShowAddFormCanvas(() => true)}
						>
							<FASvgIcon icon={faEye} />
							View
						</Button>
					)}
				</div>

				{AgriculturalIncomesDetails ? (
					<dl className="eds-list eds-dl eds-inline-between">
						<div className="eds-list--item">
							<dt>Net Agriculture Receipt</dt>
							<dd>
								<span>
									<PriceDisplay price={AgriculturalIncomesDetails?.AgrNetIncome} />
								</span>
								<PreventEditComponent>
									<Button
										variant="transparent"
										className="icon-only"
										onClick={() => {
											setShowDeleteModal(() => AgriculturalIncomesDetails);
										}}
									>
										<FASvgIcon icon={faTrash} />
									</Button>
								</PreventEditComponent>
							</dd>
						</div>
					</dl>
				) : null}
			</section>

			<OIAgriculturalIncomeDetailsForm
				showCanvas={showAddFormCanvas}
				handleCloseBtnPress={(incomeData) => {
					if (incomeData) {
						handleTotalCalculation(incomeData);
					}
					setShowAddFormCanvas(() => false);
				}}
				formValues={AgriculturalIncomesDetails}
			/>

			<ConfirmationModal
				showModal={!!showDeleteModal}
				iconColorClass="text-danger"
				title="Are you sure?"
				message={<p>You want to delete Agricultural Income</p>}
				onYesBtnClick={() => {
					handleTotalCalculation(null);
					setShowDeleteModal(() => null);
				}}
				onNoBtnClick={() => setShowDeleteModal(() => null)}
				icon={faTrashAlt}
			/>
		</>
	);
};

export default OIAgriculturalIncomeDetails;
